import { render, staticRenderFns } from "./details-process.vue?vue&type=template&id=77adfbe7&"
import script from "./details-process.vue?vue&type=script&lang=js&"
export * from "./details-process.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports